import Vue from 'vue'
import {
    formatNumber,
    formatNumberTo3SD,
    formatCurrency,
    formatOrdinal,
} from '@/utils'

Vue.filter('formatNumber', formatNumber)
Vue.filter('formatNumberTo3SD', formatNumberTo3SD)
Vue.filter('formatCurrency', formatCurrency)
Vue.filter('formatOrdinal', formatOrdinal)
